export const parseImg = (imgString) => {
    if (imgString !== undefined) {
        return imgString.split(';').map(elem => elem.trim()).slice(0, -1);
    }
}